<button class="font-noto tw-new-button {{class}}" (click)="onClick($event)" [disabled]="disabled" #csbtn="">
  <div class="tw-font-semibold tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap">
  <div *ngTemplateOutlet="csBtn"></div>
  </div>
  <ng-content></ng-content>
  <loading class="pos-abs vh-center" *ngIf="loading" [stroke]="loadingColor" [scale]="0.8"></loading>
</button><ng-template #csBtn=""><ng-content *ngIf="!loading" select="cs-button-text"></ng-content></ng-template>